import { render } from "./PatientEncounters.vue?vue&type=template&id=d00053d6&ts=true"
import script from "./PatientEncounters.vue?vue&type=script&lang=ts"
export * from "./PatientEncounters.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__